const moduleRoute = {
  path: '/convenios',
  component: () => import('@/views/Home.vue'),
  meta: { requiresAuth: true },
  children: [
    {
      path: ':id?',
      component: () => import('./views/Home.vue')
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
